import { render, staticRenderFns } from "./SymposiumStageDetail.vue?vue&type=template&id=233a12e4&scoped=true"
import script from "./SymposiumStageDetail.vue?vue&type=script&lang=js"
export * from "./SymposiumStageDetail.vue?vue&type=script&lang=js"
import style0 from "./SymposiumStageDetail.vue?vue&type=style&index=0&id=233a12e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233a12e4",
  null
  
)

export default component.exports